import * as React from 'react';
import { createService } from '../../createService';
import { TopIcon } from '../../icons';

export const TopBetService = createService({
  title: 'Ваша ставка',
  subTitle: 'Топ',
  description: ['Максимум звонков', 'Выше конкурентов', 'Большая карточка и 4 фото'],
  dataName: 'TopBetService',
  bgColor: 'gradient',
  icon: <TopIcon />,
});
